<ng-template #text>
  <ng-content select="[text]"></ng-content>
</ng-template>

<ng-container *ngIf="!isReadOnly">
  <ng-template #editableTooltip>
    <div>
      <loader [show]="isLoading" [delay]="0"></loader>
      <form #dynForm="tooltipDynamicForm" editable-tooltip-dynamic-form [controls]="controls">
        <div class="control-group">
          <ng-content select="[editable]"></ng-content>
          <div class="commands mt-2">
            <button type="button" class="btn btn-default me-2" (click)="onClose()">
              <i class="fa fa-lg fa-times"></i>
            </button>
            <button type="button" class="btn btn-success" (click)="dynForm.isValid() ? onSave() : null">
              <i class="fa fa-lg fa-check"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <ng-container *ngTemplateOutlet="text"></ng-container>
  <a class="editable editable-open"
     #tooltip="ngbTooltip"
     [ngbTooltip]="editableTooltip"
     [autoClose]="false"
     (shown)="onOpen()"
     triggers="click"
     placement="top"></a>
</ng-container>
<ng-container *ngIf="isReadOnly then text"></ng-container>
